<template>
  <li
    @mouseenter="selectMessage"
    @mouseleave="isHovered = false;"
    class="sm-messages__main-messages-list-item"
    :class="{ selected: selectedMessage.id == message.id && isHovered, 'bordered': isAtConfirmBlock }"
  >
    <div class="avatar">
      <img-loader v-if="message.sender_avatar" :src="message.sender_avatar" />
      <include-svg v-else :name="'icon-no-avatar'" />
    </div>
    <div class="details">
      <div class="info">
        <h5
          class="sm-text-simple-truncate"
          :class="{ 'sm-text-muted': message.deleted }"
        >
          {{ getFullName(message.created_by) }}
        </h5>
        <p class="sm-text-muted sm-text-simple-truncate time">
          {{ message.created_at | moment("h:mm A") }}
        </p>
        <span
          v-if="
            !isMobile && 
            !selectedMessage.deleted &&
            selectedMessage.id == message.id && 
            isHovered && !isAtConfirmBlock && 
            userAccount.id == message.created_by.id
          "
          @click="deleteMessage"
          ><include-svg :name="'icon-messages-delete'"
        /></span>
      </div>
      <div>
        <p class="content">
          <span class="sm-text-muted sm-text-italic" v-if="message.deleted"
            >This message was deleted.</span
          >
          <span v-else>{{ message.content }}</span>
        </p>

        <div
          class="attachments"
          v-if="!message.deleted && message.attachments && message.attachments.length > 0"
        >
          <a
            v-if="isImg(message.attachments[0])"
            target="_blank"
            :href="message.attachments[0]"
          >
            <img-loader
              v-if="isImg(message.attachments[0])"
              :src="message.attachments[0]"
            />
          </a>

          <a
            v-else
            class="file"
            :class="{ active: isSelected }"
            target="_blank"
            :href="message.attachments[0]"
          >
            <span class="icon-wrapper">
              <include-svg :name="'icon-messages-pdf'" />
            </span>
            <span>{{ getFileName(message.attachments[0]) }}</span>
          </a>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import ImgLoader from "@/components/ImgLoader";
import { mapGetters } from "vuex";
export default {
  name: "message-item",
  components: {
    "img-loader": ImgLoader,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    selectedMessage: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    isAtConfirmBlock: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHovered: true,
    };
  },
  computed: {
    ...mapGetters({
      userAccount: "account/userAccount",
    }),
    isSelected() {
      return (
        this.selectedMessage.id && this.selectedMessage.id === this.message.id
      );
    },
  },
  methods: {
    getFileName(url) {
      return url.substring(url.lastIndexOf("/") + 1).replaceAll("%20", " ");
    },
    getFullName(person) {
      if (person.full_name) return person.full_name;
      else return person.first_name + " " + person.last_name;
    },
    isImg(file) {
      const type = this.getFileType(file);
      const supportedTypes = ["jpg", "jpeg", "png", "gif"];
      const index = supportedTypes.indexOf(type);
      return index > -1;
    },
    getFileType(url) {
      return url.substring(url.lastIndexOf(".") + 1);
    },
    selectMessage() {
      this.isHovered = true;
      this.$parent.$emit("selectMessage", this.message);
    },
    unselectMessage() {
      this.$parent.$emit("selectMessage", {});
    },
    deleteMessage() {
      this.$parent.$emit("deleteSelectedMessage");
    },
  },
};
</script>

